import * as yup from 'yup'
export const useStepFourValidation = () => {
	const stepFourValidationSchema = yup.object({
		levels: yup.array().required('Grade Level is required').min(1)
	})

	return { stepFourValidationSchema }
}
